module.exports = __webpack_public_path__ + "static/media/back-arrow-light.d85ef257.svg";